import { render, staticRenderFns } from "./ProviderComponentDetail.vue?vue&type=template&id=257a3cc2&scoped=true"
import script from "./ProviderComponentDetail.vue?vue&type=script&lang=js"
export * from "./ProviderComponentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a3cc2",
  null
  
)

export default component.exports